export const GITHUB_REPO_URL = "https://github.com/lukemt/iwab";
export const EMAIL_SERVICE_ENDPOINT_URL = "https://82axycr3l3.execute-api.us-east-1.amazonaws.com/dev/users";
